import * as React from 'react';

import styled, { css } from 'styled-components';

interface BellIconProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
  hasNotification: boolean;
  isHovered: boolean;
}

export const BellIcon: React.FC<BellIconProps> = ({
  className,
  hasNotification,
  isHovered,
  ...props
}) => {
  return (
    <svg
      className={className}
      width="13"
      height="16.5"
      viewBox="0 0 13 16.5"
      {...props}
    >
      <StyledPath
        isHovered={isHovered}
        d="M6 16.5c1.2 0 2.3-0.9 2.5-2h-5C3.7 15.6 4.8 16.5 6 16.5z"
      />
      <StyledPath
        isHovered={isHovered}
        d="M12 11.4c0 0.1 0 0.2 0 0.3 -0.1 0.5-0.6 0.8-1.1 0.8H1.1c-0.5 0-1-0.3-1.1-0.8 0-0.1 0-0.2 0-0.3 0-0.3 0.1-0.6 0.4-0.8 0.9-0.8 1.4-1.9 1.4-3.1V5.8c0-2.4 1.9-4.3 4.2-4.3 0.1 0 0.2 0 0.3 0 0.3 0 0.6 0.1 0.9 0.2 1.8 0.5 3 2.2 3 4.1v1.7c0 1.2 0.5 2.4 1.4 3.1C11.9 10.8 12 11.1 12 11.4z"
      />
      {hasNotification ? (
        <>
          <ClipPath
            isHovered={isHovered}
            d="M10.2 5.8V7c-0.1 0-0.1 0-0.2 0C7.8 7 6 5.2 6 3c0-0.5 0.1-1 0.3-1.5 0.3 0 0.6 0.1 0.9 0.2C8.9 2.2 10.2 3.8 10.2 5.8z"
          />
          <StyledCircle cx="10" cy="3" r="3" />
        </>
      ) : null}
    </svg>
  );
};

export default BellIcon;

const StyledCircle = styled.circle`
  fill: ${({ theme }) => theme.colors.accent};
`;

const StyledPath = styled.path<{ isHovered: boolean }>`
  fill: ${({ isHovered }) =>
    isHovered
      ? css`
          ${({ theme }) => theme.colors.differentBackground}
        `
      : css`
          ${({ theme }) => theme.colors.primary}
        `};

  transition: fill
    ${({ theme }) => `${theme.transitions.duration} ${theme.transitions.type}`};
`;

const ClipPath = styled.path<{ isHovered: boolean }>`
  fill: ${({ isHovered }) =>
    isHovered
      ? css`
          ${({ theme }) => theme.colors.primary}
        `
      : css`
          ${({ theme }) => theme.colors.lightGray}
        `};
  transition: fill
    ${({ theme }) => `${theme.transitions.duration} ${theme.transitions.type}`};
`;
